// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"360":"a979ebe7","540":"45afaa21","592":"6ab06f99","721":"fc30d29d","946":"8e9b1ece"}[chunkId] + ".chunk.js";
};